module.exports = __webpack_public_path__ + "static/media/GT04_AT_Room-Types.1ed77ddf.csv";